import type { IconData } from '@stacksjs/iconify-core'

export const airplay: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M464 47H48a32.036 32.036 0 0 0-32 32v297a32.036 32.036 0 0 0 32 32h76.448l24.89-32H48V79h416l.02 297H362.662l24.89 32H464a32.036 32.036 0 0 0 32-32V79a32.036 32.036 0 0 0-32-32\"/><path fill=\"currentColor\" d=\"M98.834 496h314.332L256 293.939Zm65.431-32L256 346.061L347.735 464Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default airplay
